<template>
  <div class="basic_box">
    <el-form :model="baseGoodsData" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm"
      style="width: 70%">
      <el-form-item label="商品分类" prop="baseCategoryName">
        <div class="elinputbox">
          <el-select ref="configSelect" v-model="baseGoodsData.baseCategoryName" placeholder="请选择">
            <el-option value="baseCategoryName" style="height: auto; background: #ffffff">
              <el-tree ref="tree_box" :data="options" :props="defaultProps" node-key="name" @node-click="nodeExpand">
              </el-tree>
            </el-option>
          </el-select>
        </div>
      </el-form-item>
      <el-form-item label="商品名称" prop="title">
        <input type="text"
          style="border: 1px solid #DCDFE6;height: 35px;width: 100%;padding: 0 15px;box-sizing: border-box;border-radius: 4px;"
          v-model="baseGoodsData.title" />
      </el-form-item>
      <el-form-item label="副标题">
        <input type="text"
          style="border: 1px solid #DCDFE6;height: 35px;width: 100%;padding: 0 15px;box-sizing: border-box;border-radius: 4px;"
          v-model="baseGoodsData.subTitle" />
      </el-form-item>
      <el-form-item label="商品编码">
        <input type="text" class="goodsCodeInp" v-model="baseGoodsData.goodsCode" />
      </el-form-item>
      <el-form-item label="商品图片" prop="goods_img">
        <el-upload ref="uploadImage" :action="request_img" list-type="picture-card" :on-preview="handlePictureCardPreview"
          :on-success="upload_success" :on-change="changeImge" :on-remove="removeImg" :auto-upload="false" :limit="6"
          :file-list="wait_imgs" :headers="request_head">
          <i class="el-icon-plus"></i>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible">
          <img width="100%" :src="dialogImageUrl" alt="" />
        </el-dialog>
      </el-form-item>
      <el-form-item label="商品参数">
        <div class="goodsParame">
          <div style="overflow: auto;">
            <div class="goodsFloat" :key="item.id" v-for="item in baseGoodsData.specPropList">
              <div style="display: flex;align-items: center;">
                <div style="width: 80px;text-align: left;">{{ item.name }}:</div>
                <el-input v-if="item.paramType == 'text' || item.paramType == 'numeric'" style="width: 280px;"
                  placeholder="请输入内容" :disabled="item.readonly" v-model="item.value" :value="item.value">
                </el-input>
                <el-select v-else v-model="item.value" placeholder="请选择">
                  <el-option v-for="(itemm, index) in item.specsPropsValues" :value="itemm" :key="index" :label="itemm">
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>



          <!-- 商品参数 -->
          <div style="overflow: auto;" v-if="baseGoodsData.paramsSpecsArr.length != 0">
            <div v-for="(res, index) in baseGoodsData.paramsSpecsArr" :key="index"
              style="display: flex;float: left;margin-top: 10px;">
              <!-- 换组件 -->
              <el-select v-model="res.name" @change="selectChangeName(res, $event)" allow-create filterable
                placeholder="请选择">
                <el-option v-for="itemm in newNamesList" :key="itemm.id" :label="itemm.name" :value="itemm.name">
                </el-option>
              </el-select>
              <!-- 值 -->
              <el-select v-model="res.value" @change="selectChangeValue(res, $event)" allow-create filterable
                placeholder="请选择">
                <el-option v-for="(itemm, ind) in newValueList" :key="ind" :label="itemm" :value="itemm">
                </el-option>
              </el-select>
              <!-- 自定义未修改 -->
              <!-- <el-input style="width: 120px;" v-model="item.name" placeholder="自定义参数名"></el-input>
              <el-input style="width: 260px;" v-model="item.value[0]" placeholder="自定义参数值"></el-input> -->
              <!-- 未修改 -->
              <el-popconfirm title="您确定要删除吗？" @confirm="deletePormise(index)">
                <div style="margin-left:10px;margin-right: 20px;color: #0A72F8;cursor: pointer;" slot="reference">删除</div>
              </el-popconfirm>
            </div>
          </div>

          <el-button icon="el-icon-plus" @click="addParamClick" size="mini">添加参数</el-button>
        </div>
      </el-form-item>
      <el-form-item label="商品详情">
        <tiptap style="width: 100%; z-index: 99999" @changTiptap="change_detail" :goodsDetail="baseGoodsData.detail">
        </tiptap>
      </el-form-item>
      <el-form-item label="物流运费">
        <el-radio-group v-model="baseGoodsData.freightType" @input="chooseFreight">
          <div class="yunfeiInput" style="display: flex;align-items: center;margin-bottom: 20px;">
            <el-radio :label="0">统一邮费</el-radio>
            <el-input v-model="baseGoodsData.freightPrice" placeholder="0.00"></el-input>
          </div>
          <div class="yunfeiMuban" style="display: flex;align-items: center;">
            <el-radio :label="1">运费模板</el-radio>
            <el-select v-model="baseGoodsData.freightTemplateId" placeholder="请选择">
              <el-option v-for="item in yunfeiList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
            <el-link type="primary" @click="tonew" style="margin: 0 12px;font-size: 12px;">新建</el-link>
            <el-link type="info" :underline="false" style="font-size: 12px;">运费模板支持按地区、件数、重量计算运费</el-link>
          </div>
        </el-radio-group>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import tiptap from "./tiptap.vue";
import { get_category, addSpecsData, get_goods_specs, addSpecsName, getCustomSpecs, get_yunfei } from "@/request/api/goods";//get_basgoods,
import cookies from "vue-cookies";
import url from "@/request/url"
export default {
  components: {
    tiptap,
  },
  props: ["baseGoodsData"],
  data() {
    return {
      wait_imgs: [],
      newNamesList: [],
      newValueList: [],
      request_img: url.baseURL + "/common/upload",
      request_head: {
        "PC-LOGIN-SESSION-ID": cookies.get("supplier_token"),
      },
      defaultProps: {
        children: "children",
        label: "name",
      },
      yunfeiList: [],
      dialogImageUrl: "",
      dialogVisible: false,
      options: [],
      newPropId: 0,//临时存放新建参数id
      rules: {
        goods_template: [
          { required: true, message: "请选择商品模板", trigger: "change" },
        ],
        goods_img: [
          { required: true, message: "请选择图片", trigger: "change" },
        ],
        baseCategoryName: [
          { required: true, message: "请选择商品分类", trigger: "blur" },
        ],
        desc: [{ required: true, message: "请填写活动形式", trigger: "blur" }],
        title: [{ required: true, message: "请输入商品名称", trigger: "blur" }],
      },
    };
  },
  created() {
    // 获取分类树
    get_category().then((res) => {
      this.options = res.data;
    });
    get_yunfei().then(res => {
      this.yunfeiList = res.data
      console.log(res.data)
    })
    this.getCustomArr()
  },
  methods: {
    chooseFreight(e){
      console.log(e)
      this.$forceUpdate()
    },
    selectChangeName(item, e) {
      console.log(item)
      console.log(e)
      // 判断是否已有
      if (this.newNamesList.some(itemm => itemm.name == e)) {
        console.log('不用新增')
        console.log(this.newNamesList)
        this.newNamesList.forEach(ress => {
          if (ress.name == e) {
            console.log(ress)
            this.newPropId = ress.id
            console.log(ress.specsPropsValues)
            this.newValueList = ress.specsPropsValues
          }
        })
      } else {
        console.log('需要请求新增')
        addSpecsName({ name: e, propType: 0 }).then(res => {
          console.log(res)
          this.newPropId = res.data
          item.id = res.data
        })
      }
    },
    selectChangeValue(item, e) {
      item.value = e
      // 判断需要新增吗
      if (!this.newValueList.some(itemm => itemm == e)) {
        addSpecsData({ id: this.newPropId, specsPropsValues: [e] }).then(res => {
          console.log(res)
        })
      }
      console.log(item)
      console.log(e)
    },
    newAddSpecs(e) {
      console.log(e)
      addSpecsName({ name: e.name, propType: 0 }).then(res => {
        console.log(res)
        let obj = {
          value: [],
          name: e.name,
          id: res.data
        }
        this.newPropId = res.data
        this.specsNameList.push(obj)
        // _this.getConcatArr()
      })
    },
    // 获取自定义的商品参数
    getCustomArr() {
      getCustomSpecs(0).then(res => {
        console.log(res)
        this.newNamesList = res.data
        // // 获取自定义的规格
        // this.baseGoodsData.customSpecsList = res.data
      })
    },
    inputChange(i, e) {
      console.log(i)
      console.log(e)
    },
    addParamClick() {
      let data = { name: "", value: "", id: 0, values: [], }
      this.baseGoodsData.paramsSpecsArr.push(data)
      console.log(this.baseGoodsData.paramsSpecsArr)
    },
    deletePormise(index) {
      this.baseGoodsData.paramsSpecsArr.splice(index, 1)
    },
    tonew() {
      this.$router.push({
        name: 'template',
        params: {
          id: 0,
        },
      });
    },
    nodeExpand(data) {
      let a = this.$refs.tree_box.getNode(data.name)
      if (!a.childNodes.length) {
        this.baseGoodsData.baseCategoryId = data.id
        this.baseGoodsData.baseCategoryName = a.data.name
        // 获取商品参数
        get_goods_specs(data.id).then(res => {
          this.baseGoodsData.specPropList = res.data.specPropList //商品属性
          this.baseGoodsData.skuPropList = res.data.skuPropList //规格属性
        })
        this.$forceUpdate()
      }
    },
    change_detail(e) {
      this.baseGoodsData.detail = e;
    },
    // // 图片转换
    // return_img_list(e) {
    //   if (e) {
    //     let arr = e.split(",");
    //     let arr_img = [];
    //     arr.forEach((item) => {
    //       let obj = {
    //         name: "",
    //         url: item,
    //       };
    //       arr_img.push(obj);
    //     });
    //     return arr_img;
    //   } else {
    //     return [];
    //   }
    // },
    // 封装图片有没有上传的
    transformIsTrue(fileList) {
      return fileList.some(item => item.status == "ready")
    },
    changeImge(file, fileList) {  //图片状态被改变时触发 ----> 失败，等待中，成功
      console.log(file)
      this.$emit('isUp', this.transformIsTrue(fileList))

    },
    upload_success(res, file, fileList) {
      console.log(res);
      console.log(file);
      let istrue = fileList.every((item) => item.status == "success"); //每一项都上传完毕的标志
      if (istrue) {
        this.up_img_data(fileList);
        this.$emit('allSuccess')
      }
      //有图片上传  ready
    },
    removeImg(file, fileList) {
      if (this.baseGoodsData.images) {
        let arr = this.baseGoodsData.images.split(',')
        this.baseGoodsData.images = arr.filter((x) => x !== file.url).join(",")
      }
      console.log(fileList)
      this.$emit('isUp', this.transformIsTrue(fileList))
    },
    // 处理图片上传格式
    up_img_data(fileList) {
      this.baseGoodsData.images = ""; //处理时先清空
      fileList.forEach((item) => {
        //每项处理为待上传格式
        if (item.response) {
          if (this.baseGoodsData.images) {
            this.baseGoodsData.images =
              this.baseGoodsData.images + "," + item.response.data.url;
          } else {
            this.baseGoodsData.images = item.response.data.url;
          }
        } else {
          //原有的图片直接取地址
          if (this.baseGoodsData.images) {
            this.baseGoodsData.images =
              this.baseGoodsData.images + "," + item.url;
          } else {
            this.baseGoodsData.images = item.url;
          }
        }
      })
    },
    handlePictureCardPreview(file) {
      console.log(file.url)
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.goodsCodeInp {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  width: 100%;
  height: 35px;
  padding-left: 15px;
  box-sizing: border-box;
}

.goodsParame {
  background-color: #f8f8f8;
  padding: 10px 20px;

  .goodsFloat {
    float: left;
    margin-right: 20px;
    margin-bottom: 12px;
  }
}

.yunfeiMuban /deep/ .el-input__inner {
  height: 25px !important;
  line-height: 25px !important;
}

.yunfeiMuban /deep/ .el-input__icon {
  line-height: 25px;
}

.yunfeiInput /deep/ .el-input__inner {
  height: 25px !important;
  line-height: 25px !important;
}

.elinputbox /deep/ .el-select {
  width: 100%;
}

.basic_box /deep/ .el-form-item {
  margin-bottom: 15px;
}

.basic_box /deep/ .el-input__inner {
  height: 35px;
  line-height: 35px;
}
</style>